module.exports = __webpack_public_path__ + "img/EdConnect Login Button_Chi.bed96cc3.png";